module.exports = __webpack_public_path__ + "static/media/GoogleSans-Italic.f94165bb.woff2";